import * as Constants from '../constants/authorized-users';


export const getAuthorizedUser = ($http, ENV, userId, authorizedUserId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_AUTHORIZED_USER_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/authorized-users/${authorizedUserId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_AUTHORIZED_USER_SUCCESS, payload: res.data.users });
        resolve(res.data.users);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_AUTHORIZED_USER_FAILED, payload: error });
        reject(error);
      });
  });

export const blockUnblockAuthorizedUser = ($http, ENV, userId, authorizedUserId, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_AUTHORIZED_USER_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/authorized-users/${authorizedUserId}/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_AUTHORIZED_USER_SUCCESS, payload: res.data.users });
        resolve(res.data.users);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_AUTHORIZED_USER_FAILED, payload: error });
        reject(error);
      });
  });

export const cancelRemoveAuthorizedUser = ($http, ENV, userId, authorizedUserId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.DELETE_AUTHORIZED_USER_REQUEST });

    $http({
      method: 'DELETE',
      url: ENV.apiEndpoint + `/2.0/users/${userId}/authorized-users/${authorizedUserId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.DELETE_AUTHORIZED_USER_SUCCESS, payload: res.data.users });
        resolve(res.data.users);
      })
      .catch((error) => {
        dispatch({ type: Constants.DELETE_AUTHORIZED_USER_FAILED, payload: error });
        reject(error);
      });
  });

export const setActiveAuthorizedUser = (authorizedUser) => ({
  type: Constants.SET_ACTIVE_AUTHORIZED_USER,
  payload: authorizedUser,
});